var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageLayout',[(_vm._config)?_c(_vm._config.lotteryHall
        ? _vm._config.lotteryHall.configValue.templateApp || _vm._config.lotteryHall.configValue.template || 'default'
        : 'default',{tag:"component"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }